import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSearch48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="search">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 33C26.732 33 33 26.732 33 19C33 11.268 26.732 5 19 5C11.268 5 5 11.268 5 19C5 26.732 11.268 33 19 33ZM19 35C27.8366 35 35 27.8366 35 19C35 10.1634 27.8366 3 19 3C10.1634 3 3 10.1634 3 19C3 27.8366 10.1634 35 19 35Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.3137 41.3136L29 29.9999L30.4142 28.5857L41.7279 39.8994L40.3137 41.3136Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconSearch24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="search">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.0319 15.6177C18.2635 14.078 19 12.125 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C12.125 19 14.078 18.2635 15.6177 17.0319L21.6569 23.0711L23.0711 21.6569L17.0319 15.6177ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconSearch16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="search">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 11C8.98528 11 11 8.98528 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.293 15.7072L9.29294 10.7072L10.7072 9.29297L15.7072 14.293L14.293 15.7072Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
